import { useState, useEffect } from "react";
import { ModalAtendimentos, ContainerTableAtendimentos, ContainerTableAt, ContainerControllers, ItemBtnExport, ContainerBusca } from "./styled";
import { ContainerSearch, ComponentTitle } from "../styledGlobalModal";
import axios from "axios";
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { toast } from 'react-toastify';
import CircularProgress from '@mui/material/CircularProgress';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Input, Switch, Select, Skeleton } from 'antd';
import { SearchOutlined, EditOutlined, LogoutOutlined } from '@ant-design/icons';
import { CiSearch, CiLogout, CiEdit } from "react-icons/ci";
import listTables from "./tableTitles.json"
import {
    TableContainer,
    TableBody,
    TableRow,
    TableColumn,
    TableHeader,
    ColumnTitle,
    TableTitle,
    TableHead,
} from "../../../../CSSGlobal";
import { BtnBlue, } from "../../Modal/styledGlobalModal";
import { PaginationBtn } from "../../../../styledEvents";
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Pagination from '@mui/material/Pagination';
import ModalTratamento from "./ModalTratamento";


export function Atendimentos() {

    const [exporting, setExporting] = useState(false);
    const [isExcelAvailable, setIsExcelAvailable] = useState(true);
    const [clientParam, setClientParam] = useState("");
    const [titleTable, setTitleTable] = useState(listTables);
    const [showPendentes, setShowPendentes] = useState(true);
    const [pagePendentes, setPagePendentes] = useState(1);
    const [pageEmitidas, setPageEmitidas] = useState(1);
    const [totalPagesPendentes, setTotalPagesPendentes] = useState(0);
    const [totalPagesEmitidas, setTotalPagesEmitidas] = useState(0);
    const Numberpage = 5;
    const [listTableTarefasPendentes, setListTableTarefasPendentes] = useState([]);
    const [listTableTarefasEmitidas, setListTableTarefasEmitidas] = useState([]);

    const [showMessagePendentes, setShowMessagePendentes] = useState(false);
    const [showMessageEmitir, setShowMessageEmitir] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true);
    const [loadingPendentes, setLoadingPendentes] = useState(initialLoad);
    const [loadingEmitidas, setLoadingEmitidas] = useState(initialLoad);
    const [isExportDisabled, setIsExportDisabled] = useState(true);
    const [reportType, setReportType] = useState("");
    const [atendimentoId, setAtendimentoId] = useState("");
    const [isModalTratamento, setIsModalTratamento] = useState(false);
    const [toastsDisplayed, setToastsDisplayed] = useState(new Set());

    const toastId = {
        successPendentes: 'successPendentes',
        successEmitidas: 'successEmitidas',
        error: 'error'
    };

    useEffect(() => {

        fetchData();
    }, [pagePendentes, pageEmitidas, clientParam]);

    useEffect(() => {
        let height = 1000;
        window.parent.postMessage({ frameHeight: height }, "*");
      },);

    const fetchData = async () => {
        const url = "/portal/rest/contador/atendimento/pesquisar";
        const dataPendentes = {
            atendimento: { memo: clientParam },
            paginacao: { pagina: pagePendentes, tamanho: 5 }
        };
        const dataEmitidas = {
            atendimento: { memo: clientParam, situacao: { nome: "Processadas" } },
            paginacao: { pagina: pageEmitidas, tamanho: 5 }
        };

        setLoadingPendentes(true);
        setLoadingEmitidas(true);

        try {
            const [pendentesResponse, emitidasResponse] = await Promise.all([
                axios.post(url, dataPendentes, { withCredentials: true }),
                axios.post(url, dataEmitidas, { withCredentials: true })
            ]);

            if (Array.isArray(pendentesResponse.data.atendimentos)) {
                setListTableTarefasPendentes(pendentesResponse.data.atendimentos);
                setTotalPagesPendentes(pendentesResponse.data.paginacao.totalPaginas);
                setShowMessagePendentes(pendentesResponse.data.atendimentos.length === 0);

                if (!toastsDisplayed.has(toastId.successPendentes)) {
                   console.log("Dados pendentes carregados com sucesso!");
                    setToastsDisplayed(prev => new Set(prev).add(toastId.successPendentes));
                }
            }

            if (Array.isArray(emitidasResponse.data.atendimentos)) {
                setListTableTarefasEmitidas(emitidasResponse.data.atendimentos);
                setTotalPagesEmitidas(emitidasResponse.data.paginacao.totalPaginas);
                setShowMessageEmitir(emitidasResponse.data.atendimentos.length === 0);

                if (!toastsDisplayed.has(toastId.successEmitidas)) {
                   console.log("Dados emitidos carregados com sucesso!");
                    setToastsDisplayed(prev => new Set(prev).add(toastId.successEmitidas));
                }
            }

        } catch (error) {
            if (!toastsDisplayed.has(toastId.error)) {
                toast.error("Erro ao buscar os dados.");
                setToastsDisplayed(prev => new Set(prev).add(toastId.error));
            }
        } finally {
            setLoadingPendentes(false);
            setLoadingEmitidas(false);
        }
    };


    const exportToExcel = async (value) => {
        const excelUrl = `/portal/rest/contador/atendimento/export/excel?report=${value}&termo=${clientParam}`;

        try {
            setExporting(true);
            const response = await axios.get(excelUrl, {
                withCredentials: true,
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            let fileName = "";

            switch (value) {
                case "0":
                    fileName = 'planilha-controle-atendimentos.xlsx';
                    break;
                case "2":
                    fileName = 'atendimentos-detalhado.xlsx';
                    break;
            }

            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            toast.success("Arquivo baixado com sucesso!");
        } catch (error) {
            console.error('Erro ao exportar os dados:', error);
            toast.error('Erro ao exportar os dados, tente novamente em poucos minutos.');
        } finally {
            setExporting(false);
        }
    };

    const changeClientParam = (e) => {
        setClientParam(e.target.value);
        setInitialLoad(true);

    }

    const handleData = () => {
        fetchData();
        setInitialLoad(true);
        setIsExportDisabled(false);
    }

    const handleToggleChange = (checked) => {
        setShowPendentes(!checked);
        setPageEmitidas(1);
        setPagePendentes(1);
        // setSearchTerm("");
    };

    const handleChangePagePendentes = (event, newPage) => {
        setPagePendentes(newPage);
    };

    const handleChangePageEmitidas = (event, newPage) => {
        setPageEmitidas(newPage);
    };

    const handleChange = (value) => {
        setReportType(value);
        exportToExcel(value);
    };

    const handleModalTratamento = (id) => {
        setIsModalTratamento(!isModalTratamento);
        setAtendimentoId(id);
    }

    return (
        <ModalAtendimentos>
            <ContainerTableAtendimentos>
                <ContainerTableAt>
                    <ContainerSearch>
                        <ContainerControllers>
                            <ComponentTitle>
                                <span>{"Atendimentos"}</span>
                            </ComponentTitle>
                            {isExcelAvailable && (
                                <ItemBtnExport>
                                    {!exporting && (
                                        <>
                                            <div className="select-export">
                                                <Select
                                                    defaultValue="Exportar Excel"
                                                    style={{ width: 220, textAlign: "center" }}
                                                    onChange={handleChange}
                                                    className="select-excel"
                                                >
                                                    <Select.Option value="0">Excel - Controle Atendimentos</Select.Option>
                                                    <Select.Option value="2" disabled={isExportDisabled}>
                                                        Excel - Atendimentos Detalhados
                                                    </Select.Option>
                                                </Select>
                                            </div>
                                        </>
                                    )}
                                    {exporting && (
                                        <div>
                                            <CircularProgress
                                                className="cicleProgress"
                                                disableShrink
                                            />
                                        </div>
                                    )}
                                </ItemBtnExport>
                            )}
                        </ContainerControllers>
                    </ContainerSearch>
                    <ContainerBusca>
                        <Input
                            placeholder="Cliente ID"
                            className="input-id"
                            value={clientParam}
                            onChange={changeClientParam}
                        />
                        <Button className="button-prox"
                            onClick={handleData}
                        >
                            <SearchOutlined />
                            Próximo
                        </Button>

                    </ContainerBusca>
                </ContainerTableAt>
                <TableContainer>
                    <div className="checkbox-wrapper-34">
                        <Switch
                            checkedChildren="Emitidas"
                            unCheckedChildren="Pendentes"
                            defaultChecked
                            checked={!showPendentes}
                            onChange={handleToggleChange}
                        />
                    </div>

                    {showPendentes ? (
                        <>
                            {loadingPendentes ? (
                                <Box sx={{ width: "100%" }}>
                                    <LinearProgress />
                                </Box>
                            ) : null}
                            {loadingPendentes ? (
                                <>
                                    {[...Array(2)].map((_, index) => (
                                        <Skeleton
                                            active
                                            key={index}
                                            variant="rectangular"
                                            width="100%"
                                            height={10}
                                        />
                                    ))}
                                </>
                            ) : (
                                <>
                                    <TableHeader>
                                        <TableHead>
                                            {titleTable[0].titles.map((item, index) => {
                                                return (
                                                    <ColumnTitle key={index} id={index}>
                                                        <TableTitle>
                                                            <span>{item.title}</span>
                                                        </TableTitle>
                                                    </ColumnTitle>
                                                );
                                            })}
                                        </TableHead>
                                    </TableHeader>
                                    <TableContainer>
                                        <TableBody>
                                            <>
                                                {listTableTarefasPendentes.map((item, index) => (
                                                    <>
                                                        <TableRow key={index}>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.id}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.cliente.nome}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.cliente.carteira.id}/{item.cliente.equipe.id}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.dataCadastro}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.titulo}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.situacao.nome}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <Button className="button-prox" onClick={() => handleModalTratamento(item.id)}>
                                                                    <CiLogout className="icon-btn" />
                                                                    Tratar
                                                                </Button>
                                                            </TableColumn>
                                                        </TableRow>
                                                    </>
                                                ))}
                                            </>
                                            {showMessagePendentes && (
                                                <div className="msgFilterSearch">
                                                    <Stack className="center" sx={{ width: "100%" }} spacing={2}>
                                                        <Alert severity="info">Nenhuma tarefa Pendente.</Alert>
                                                    </Stack>
                                                </div>
                                            )}
                                        </TableBody>
                                        <PaginationBtn>
                                            <Stack spacing={1}>
                                                <Pagination
                                                    count={Math.ceil(totalPagesPendentes / Numberpage)}
                                                    page={pagePendentes}
                                                    onChange={handleChangePagePendentes}
                                                    size="small"
                                                />
                                            </Stack>
                                        </PaginationBtn>
                                    </TableContainer>
                                </>
                            )}

                        </>
                    ) : (
                        <>
                            {loadingEmitidas ? (
                                <Box sx={{ width: "100%" }}>
                                    <LinearProgress />
                                </Box>
                            ) : null}
                            {loadingPendentes ? (
                                <>
                                    {[...Array(2)].map((_, index) => (
                                        <Skeleton
                                            active
                                            key={index}
                                            variant="rectangular"
                                            width="100%"
                                            height={10}
                                        />
                                    ))}
                                </>
                            ) : (
                                <>
                                    <TableHeader>
                                        <TableHead>
                                            {titleTable[1].titles.map((item, index) => {
                                                return (
                                                    <ColumnTitle key={index} id={index}>
                                                        <TableTitle>
                                                            <span>{item.title}</span>
                                                        </TableTitle>
                                                    </ColumnTitle>
                                                );
                                            })}
                                        </TableHead>
                                    </TableHeader>
                                    <TableContainer>
                                        <TableBody>
                                            <>
                                                {listTableTarefasEmitidas.map((item, index) => (
                                                    <>
                                                        <TableRow key={index}>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.id}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.cliente.nome}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.cliente.carteira.id}/{item.cliente.equipe.id}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.dataCadastro}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.titulo}
                                                                </span>
                                                            </TableColumn>
                                                            <TableColumn>
                                                                <span>
                                                                    {item.situacao.nome}
                                                                </span>
                                                            </TableColumn>

                                                            <TableColumn>
                                                                <Button className="button-prox" onClick={() => handleModalTratamento(item.id)}>
                                                                    <EditOutlined className="icon-btn" />
                                                                    Editar
                                                                </Button>
                                                            </TableColumn>
                                                        </TableRow>
                                                    </>
                                                ))}
                                            </>
                                            {showMessageEmitir && (
                                                <div className="msgFilterSearch">
                                                    <Stack className="center" sx={{ width: "100%" }} spacing={2}>
                                                        <Alert severity="info">Nenhuma tarefa Emitida.</Alert>
                                                    </Stack>
                                                </div>
                                            )}
                                        </TableBody>
                                        <PaginationBtn>
                                            <Stack spacing={1}>
                                                <Pagination
                                                    count={Math.ceil(totalPagesEmitidas / Numberpage)}
                                                    page={pageEmitidas}
                                                    onChange={handleChangePageEmitidas}
                                                    size="small"
                                                />
                                            </Stack>
                                        </PaginationBtn>
                                    </TableContainer>
                                </>
                            )}
                        </>
                    )}
                </TableContainer>
            </ContainerTableAtendimentos>
            {isModalTratamento && (
                <ModalTratamento
                    isOpen={isModalTratamento}
                    onClose={() => setIsModalTratamento(false)}
                    id={atendimentoId}
                    fetchPendentesData={fetchData}
                    fetchEmitidasData={fetchData}
                />
            )}
        </ModalAtendimentos>
    );
}

export default Atendimentos;